import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n";
import { PublicNav } from "@/components/PublicNav";
import { TrustBar } from "@/components/TrustBar";
import { Input } from "@/components/ui/input";
import { ShieldCheck, Lock, FileText, Landmark, Search, ExternalLink, Phone } from "lucide-react";

const PRINCIPLES = [
  { icon: ShieldCheck, titleKey: "tc_p1_t", descKey: "tc_p1_d" },
  { icon: FileText, titleKey: "tc_p2_t", descKey: "tc_p2_d" },
  { icon: Lock, titleKey: "tc_p3_t", descKey: "tc_p3_d" },
  { icon: Landmark, titleKey: "tc_p4_t", descKey: "tc_p4_d" },
];

export default function TrustCenter() {
  const { t } = useI18n();
  const [regs, setRegs] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/regulators").then((r) => setRegs(r.data)); }, []);
  const filtered = regs.filter((r) => r.name.toLowerCase().includes(q.toLowerCase()) || r.state.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="min-h-screen hero-bg">
      <PublicNav />
      <div className="mx-auto max-w-5xl px-5 py-12">
        <h1 className="font-display text-4xl sm:text-5xl font-semibold text-navy">{t("tc_head")}</h1>
        <p className="mt-3 text-lg text-slate-500 max-w-2xl">{t("tc_sub")}</p>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-5">
          {PRINCIPLES.map((p) => (
            <div key={p.titleKey} className="rounded-2xl bg-white border border-slate-100 card-shadow p-6">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl brand-gradient text-white"><p.icon className="h-5 w-5" /></span>
              <h3 className="mt-4 text-lg font-semibold text-navy">{t(p.titleKey)}</h3>
              <p className="mt-1.5 text-sm text-slate-500">{t(p.descKey)}</p>
            </div>
          ))}
        </div>

        <div className="mt-10"><TrustBar /></div>

        <div className="mt-12">
          <h2 className="font-display text-2xl font-semibold text-navy flex items-center gap-2"><Landmark className="h-6 w-6 text-brandblue" /> {t("tc_find_regulator")}</h2>
          <p className="mt-1 text-slate-500">{t("tc_regulator_sub")}</p>
          <div className="mt-4 relative max-w-md">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
            <Input data-testid="regulator-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder={t("tc_search_state")} className="pl-10 rounded-full bg-white" />
          </div>
          <div className="mt-5 grid grid-cols-1 md:grid-cols-2 gap-3">
            {filtered.map((r) => (
              <div key={r.state} className="rounded-2xl bg-white border border-slate-100 card-shadow p-4">
                <div className="flex items-center justify-between"><p className="font-medium text-navy text-sm">{r.name}</p><span className="rounded-md bg-slate-100 px-2 py-0.5 text-xs font-semibold text-slate-500">{r.state}</span></div>
                <div className="mt-2 flex flex-wrap gap-4 text-sm">
                  <a href={r.website} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-brandblue"><ExternalLink className="h-3.5 w-3.5" />{t("website")}</a>
                  <span className="inline-flex items-center gap-1 text-slate-500"><Phone className="h-3.5 w-3.5" />{r.phone}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
